import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import CustomButton from "components/CustomButton";

import {greyishBlue600} from "assets/jss/main";

SelectedFilters.propTypes = {
    selectedFilters: PropTypes.array,
    onRemove: PropTypes.func,
};

const CrossIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.96094 3.96069L12.0002 12" stroke="#3C81FB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.96073 12L12 3.96069" stroke="#3C81FB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

function SelectedFilters({selectedFilters = [], onRemove}) {
    if (selectedFilters.length === 0) {
        return null;
    }

    return (
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center'}}>
            <span style={{fontWeight: 'bold', color: greyishBlue600, fontSize: '14px'}}>
                <FormattedMessage id='retailer.product.list.filter.active' />
            </span>
            {selectedFilters.map((filter) => (
                <CustomButton
                    key={filter.id}
                    color={'lightBlue'}
                    rounded
                    bold={false}
                    onClick={() => onRemove(filter)}
                >
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        {filter.name || filter.value} <CrossIcon />
                    </div>
                </CustomButton>
            ))}
        </div>
    );
}

export default SelectedFilters;
